// extracted by mini-css-extract-plugin
module.exports = {"agenda":"agenda_agenda__2sKz3"};